import { useCallback } from 'react';
import { LOCAL_STORAGE, LocalStorage } from '@blink/components/src/utils';

import { useWalletConnect } from '@/shared/hooks/useWalletConnect';

export const useWalletConnectHandler = (marginAccountAddress: string, walletConnectUri: string) => {
    const { handlePair } = useWalletConnect({ marginAccountAddress });

    const connectWalletByUriHandler = useCallback(() => {
        if (!walletConnectUri) return;

        handlePair(walletConnectUri);
        LocalStorage.setItem(LOCAL_STORAGE.WALLET_CONNECT_URI, walletConnectUri);
        LocalStorage.setItem(LOCAL_STORAGE.WALLET_CONNECT_MARGIN_ADDRESS, marginAccountAddress);
    }, [walletConnectUri, marginAccountAddress, handlePair]);

    return { connectWalletByUriHandler };
};
